import styled from '@emotion/styled';

const RatingCell = styled.div`
  margin-top: 1.5rem;

  ${({ theme }) => theme.mq('md')} {
    position: absolute;
    top: 4rem;
    left: 50%;
    margin-top: 0;
  }

  ${({ theme }) => theme.mq('lg')} {
    position: static;
    margin-top: 1.5rem;
  }
`;

const Card = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem;
  border-radius: ${({ theme }) => theme.radius.sm};
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-size: ${({ theme }) => theme.fontSize.xs.size};
  line-height: 1.25rem;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  box-shadow: ${({ theme }) => theme.elevation.low};
`;

const Description = styled.p`
  margin: 0;
  max-width: 11.25rem;
`;

const Stars = styled.div`
  display: flex;
  align-items: center;
`;

const Value = styled.strong`
  padding: 0 0.5rem;
  font-weight: 600;
`;

export { RatingCell, Card, Description, Stars, Value };
